import React from 'react'
import '../App.css'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
//import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

import ReactTooltip from "react-tooltip"
import * as d3 from 'd3';
//import { FormHelperText } from '@material-ui/core';

const styles = theme => ({

  container: {
    fontFamily: 'Flanders Art Sans!important',
    backgroundColor: '#ffffff',
    border: '1px solid black',
    //flexDirection: 'row',
    //justifyContent: 'space-between',
  },
  bottomMargin: {
    bottomMargin: '2em',
  },
  yearButton: {
    fontFamily: 'Flanders Art Sans!important',
    fontSize: '12pt',
    padding: '2em!important',
    backgroundColor:'#ffffff',
  },
  activeYear: {
    backgroundColor: '#165469!important',
    color: '#ffffff'
  }
});


function YearCalendar(props) {
  const { classes } = props;

  let relevantYears = (new Array(props.maxYear - props.minYear + 1)).fill(undefined).map((_, i) => i + props.minYear);

  return (
    <Grid item container xs={12} spacing={0} className={classes.container}>
      <Grid item container xs={12} spacing={0} className={classes.bottomMargin}>
        <Grid item xs={4} className={"bgmediumgrey"} />
        <Grid item xs={4} className={"bglightgrey"} style={{padding:'1em 0',color:'black',}}>{props.minYear}-{props.maxYear}</Grid>
        <Grid item xs={4} className={"bgmediumgrey"} />
      </Grid>
      <Grid item container xs={12} spacing={0} className={classes.bottomMargin}>
      {
        relevantYears.map((year) => (
          <Grid
            key={year}
            item xs={4}
            className={(year === parseInt(props.selectedYear) ? (classes.activeYear + " ") : '') + classes.yearButton}
            onClick={(year)=>props.onChange(year)}
          >
            {year}
          </Grid>
        ))
      }
      </Grid>
    </Grid>
  )
}

YearCalendar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(YearCalendar)